/* eslint-disable @typescript-eslint/no-unsafe-return */
// SOMEHOW THERE IS A BUG AND IT READS THE LIST AS ANY
import { AxiosResponse } from 'axios';
import { OrderGetMinDTO, OrderEditDTO, OrderTitleMatchingUpdateDTO } from 'svila-common';

import { API_URL } from '../../utils/constants';
import request from '../request';

export default {
  get: async (id: string): Promise<AxiosResponse<OrderGetMinDTO>> => {
    return request(`${API_URL}/orders/${id}`, 'get');
  },
  update: async (id: string, values: OrderEditDTO): Promise<AxiosResponse<OrderGetMinDTO>> => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/orders/${id}`, 'put', body, {});
  },
  create: async (values: OrderEditDTO): Promise<AxiosResponse<OrderGetMinDTO>> => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/orders/`, 'post', body, {});
  },
  delete: async (id: string): Promise<AxiosResponse<OrderGetMinDTO>> => {
    return request(`${API_URL}/orders/${id}`, 'delete', {}, {});
  },
  getMatchings: async (id: string): Promise<AxiosResponse<OrderGetMinDTO[]>> => {
    return request(`${API_URL}/orders/title-matchings/${id}`, 'get');
  },
  updateMatchings: async (
    id: string,
    values: OrderTitleMatchingUpdateDTO,
  ): Promise<AxiosResponse<OrderGetMinDTO[]>> => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/orders/title-matchings/${id}`, 'put', body, {});
  },
  printout: async (id: string): Promise<AxiosResponse<OrderGetMinDTO[]>> => {
    return request(`${API_URL}/orders/printout/${id}`, 'get', {}, {});
  },
  getCustomsExcel: async (id: string) => {
    return request(`${API_URL}/orders/customs/get-full-excel/${id}`, 'get', null, null, {
      responseType: 'arraybuffer',
    });
  },
  getCustomsPackingListExcel: async (id: string) => {
    return request(`${API_URL}/orders/customs/get-customs-packing-list-excel/${id}`, 'get', null, null, {
      responseType: 'arraybuffer',
    });
  },
  getExternalOrdersQuantity: async () => {
    return request(`${API_URL}/orders/external-orders-quantity`, 'get');
  }
};
